import { MutableRefObject, Ref } from 'react';
import { focusableElementsString } from '~/constants';

// Given a ref, this function focuses on
// the closest focusable element previous to the ref in the dom tree
export const focusPrevious = (ref: MutableRefObject<HTMLElement>) => {
  // Get all the focusable elements inside the previous sibling
  const focusableElements = (
    ref.current?.previousSibling as HTMLElement
  ).querySelectorAll(focusableElementsString) as NodeListOf<HTMLElement>;
  focusableElements[focusableElements.length - 1]?.focus();
};

// Does anything in the document currently have keyboard focus?
export const anythingHasFocus = () =>
  document.querySelector(':focus-visible, .Mui-focusVisible, :focus') !== null;
